<div [ngClass]="{ 'background-lighttheme': theme == 'light', 'background-darktheme': theme == 'dark' }" > 

    <div [ngClass]="{ 'text-lighttheme': theme == 'light', 'text-darktheme': theme == 'dark' }" style="margin-top: 10%; text-align: center; width: 100%; display: flex; flex-direction: column; justify-content: center; height: 100%;">
        <span style="font-size: 8vw">Current Pot</span>
        <span style="font-size: 12vw">{{ currentPotSize | currency : 'USD' : 'symbol' : '1.0-0' }}</span>
    </div>

</div>
